module.exports = __webpack_public_path__ + "static/img/chat3.4cfb3d3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showcase/championscity/challenge/chat3.png
// module id = Ow/v
// module chunks = 1